// extracted by mini-css-extract-plugin
export default {"wrapper":"AdaptiveTable_wrapper__yUUX+","table":"AdaptiveTable_table__XCZ3A","mobileLabel":"AdaptiveTable_mobileLabel__MeQW9"};